import { Page } from '@nearst/ui';

import ReportOverviewCard from '../components/ReportOverviewCard';
import { reports } from '../reports';

import ExportDataIllustration from '../../../assets/images/reports/export-data.svg';
import styles from './ReportsOverview.module.scss';

export const ReportsOverview = () => {
	const availableReports = reports.filter((report) => !report.advanced);
	const advancedReports = reports.filter((report) => report.advanced);

	return (
		<>
			<Page.Header>
				<h1>Reports library</h1>
				<p>See the impact of your inventory across channels.</p>
			</Page.Header>
			<Page.Section>
				<div className={styles.cards}>
					{availableReports.map((report) => (
						<ReportOverviewCard key={report.id} {...report} />
					))}
				</div>

				<h3>Advanced reports</h3>

				<div className={styles.cards}>
					{advancedReports.map((report) => (
						<ReportOverviewCard key={report.id} {...report} />
					))}
				</div>

				<h3>Export data</h3>
				<div className={styles.cards}>
					<ReportOverviewCard
						id="export-data"
						image={ExportDataIllustration}
						title="Export data"
						description="Download raw data to build your own reports."
					/>
				</div>
			</Page.Section>
		</>
	);
};
